/**
 * Determine if an annotation is in nag format
 */
export function isNagFormat(annotation: string): boolean {
  return Boolean(annotation && annotation.charAt(0) === '$');
}
